module.exports = __webpack_public_path__ + "static/media/olympic_medals.4b117a67.jpg";